import { useEffect } from 'react';
import MarketingLayout from './MarketingLayout';
import { pageTitle } from './marketingCopy';
import LandingPage from './pages/LandingPage';
import DemoPage from './pages/DemoPage';
import {
  CollateralHome,
  ComparePage,
  DeckPage,
  DemoScriptPage,
  DemoTourPage,
  EnablementPage,
  FaqPage,
  JobsPage,
  OnePagerPage,
  PricingPage,
  VideoScriptPage,
} from './pages/SimplePages';
import { DpaPage, PrivacyPage, SubprocessorsPage, TermsPage, TrustPage } from './pages/LegalPages';

export { isMarketingPath } from './marketingCopy';
export { usePath } from './usePath';

export default function MarketingApp({ path, navigate, signedIn, onSignIn, onOpenApp }) {
  useEffect(() => {
    document.title = pageTitle(path);
    const meta = document.querySelector('meta[name="description"]');
    if (meta && path === '/') {
      meta.setAttribute(
        'content',
        'Orca AI — Fusion HCM Security & Approvals. Copilot for Oracle Fusion HCM security, SoD, access reviews, and BPM approvals. Not affiliated with Orca Security.'
      );
    }
  }, [path]);

  let page = null;
  switch (path) {
    case '/':
      page = (
        <LandingPage
          navigate={navigate}
          signedIn={signedIn}
          onSignIn={onSignIn}
          onOpenApp={onOpenApp}
        />
      );
      break;
    case '/jobs':
      page = <JobsPage navigate={navigate} />;
      break;
    case '/pricing':
      page = <PricingPage navigate={navigate} />;
      break;
    case '/compare':
      page = <ComparePage />;
      break;
    case '/faq':
      page = <FaqPage navigate={navigate} />;
      break;
    case '/trust':
      page = <TrustPage navigate={navigate} />;
      break;
    case '/privacy':
      page = <PrivacyPage />;
      break;
    case '/terms':
      page = <TermsPage />;
      break;
    case '/dpa':
      page = <DpaPage />;
      break;
    case '/subprocessors':
      page = <SubprocessorsPage />;
      break;
    case '/demo':
      page = <DemoPage navigate={navigate} mode="demo" />;
      break;
    case '/trial':
      page = <DemoPage navigate={navigate} mode="trial" />;
      break;
    case '/demo-tour':
      page = <DemoTourPage navigate={navigate} />;
      break;
    case '/collateral':
      page = <CollateralHome navigate={navigate} />;
      break;
    case '/collateral/one-pager':
      page = <OnePagerPage />;
      break;
    case '/collateral/demo-script':
      page = <DemoScriptPage />;
      break;
    case '/collateral/enablement':
      page = <EnablementPage />;
      break;
    case '/collateral/deck':
      page = <DeckPage />;
      break;
    case '/collateral/video-script':
      page = <VideoScriptPage />;
      break;
    default:
      page = (
        <div>
          <h1 className="text-2xl font-semibold text-orca-strong">Page not found</h1>
          <button type="button" onClick={() => navigate('/')} className="mt-3 text-sm text-cyan-400">
            Back to product
          </button>
        </div>
      );
  }

  return (
    <MarketingLayout path={path} navigate={navigate} signedIn={signedIn} onSignIn={onSignIn} onOpenApp={onOpenApp}>
      {page}
    </MarketingLayout>
  );
}
